import React from 'react';
import { Box, withStyles } from '@material-ui/core';
import {
  Modal,
  resolveCategoryMark,
  resolveMuiIconComponent,
  SelectionCard,
  Typography,
} from '@orijinworks/frontend-commons';
import styles, { AddWidgetModalStyles } from './add-widget-modal.styles';

const noop = () => {};

const renderCategoryMark = (classes, icon) => {
  const mark = resolveCategoryMark(icon);
  if (!mark) {
    return null;
  }

  if (mark.kind === 'svg') {
    return (
      <Box className={classes.categoryMark} aria-hidden="true">
        <img className={classes.categoryMarkImage} src={mark.src} alt="" />
      </Box>
    );
  }

  const Icon = mark.Icon;
  if (!Icon) {
    return null;
  }

  return (
    <Box className={classes.categoryMark} aria-hidden="true">
      <Icon />
    </Box>
  );
};

const renderWidgetTypeIcon = (iconKey) => {
  const Icon = resolveMuiIconComponent(iconKey);
  return Icon ? <Icon /> : null;
};

const WidgetTypeCategoryGroup = ({ classes, category, onSelect }) => {
  const showHeader = Boolean(category.displayName);

  return (
    <Box className={classes.category}>
      {showHeader && (
        <Box className={classes.categoryHeader}>
          <Typography className={classes.categoryTitle} variant="overlineSmall">
            {category.displayName}
          </Typography>
          {category.attributionText ? (
            <Box className={classes.categoryAttributionRow}>
              {renderCategoryMark(classes, category.icon)}
              <Typography className={classes.categoryAttribution} variant="subtitle1">
                {category.attributionText}
              </Typography>
            </Box>
          ) : null}
        </Box>
      )}
      <Box className={classes.typeList}>
        {(category.widgetTypes ?? []).map((widgetType) => (
          <SelectionCard
            key={widgetType.key}
            title={widgetType.displayName}
            description={widgetType.description ?? ''}
            icon={renderWidgetTypeIcon(widgetType.iconKey)}
            onClick={() => onSelect(widgetType)}
          />
        ))}
      </Box>
    </Box>
  );
};

function AddWidgetModal({
  classes,
  open = false,
  categories = [],
  onClose,
  onSelect,
}) {
  if (!open) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      onContinue={noop}
      heading="Add a widget"
      labelledBy="Add a widget"
      describedBy="Choose a widget type to add to this section"
      cancelBtnText=""
      actionBtnText=""
      showCrossIcon
      showFooter={false}
      modalType={{ type: 'normal', status: 'info', size: 'medium' }}
      styles={{ mainWrapperStyles: { width: 600, minWidth: 600, maxWidth: 780 } }}
      mainModalStyles={AddWidgetModalStyles}
    >
      <Box className={classes.content}>
        {categories.map((category) => (
          <WidgetTypeCategoryGroup
            key={category.key}
            classes={classes}
            category={category}
            onSelect={onSelect}
          />
        ))}
      </Box>
    </Modal>
  );
}

AddWidgetModal.defaultProps = {
  open: false,
  categories: [],
  onClose: undefined,
  onSelect: undefined,
};

export default withStyles(styles)(AddWidgetModal);
